import { render, staticRenderFns } from "./IntroductionYoonPage.vue?vue&type=template&id=6b37e5af&"
import script from "./IntroductionYoonPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionYoonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports